import Vue from 'vue';
import { print } from 'graphql/language/printer';
import { captureException } from '@sentry/browser';
import queries from '@/graphql/queries';
import mutations from '@/graphql/mutations';
import axiosApiInstance, { createResponse, createErrorResponse, getPlainAxios } from '../utils/api';

function postGraphql(queryString, variables, fetchOptions = {}, ignoreInterceptor = false) {
  const axios = ignoreInterceptor ? getPlainAxios() : axiosApiInstance;
  // always returns format of "emptyResponse"
  const data = JSON.stringify({
    query: `${print(queryString)}`,
    variables,
  });

  return new Promise((resolve, reject) => {
    axios.post('/graphql/', data, fetchOptions)
      .then(response => resolve(createResponse(response)))
      .catch((error) => {
        // Failed fetch is always an unexpected error, since expected
        // errors will be in "response.errors". Send it to sentry.
        captureException(error);
        reject(createErrorResponse(error));
      });
  });
}

const query = postGraphql;
const mutate = postGraphql;

Vue.prototype.$queries = queries;
Vue.prototype.$mutations = mutations;
Vue.prototype.$query = query;
Vue.prototype.$mutate = mutate;
Vue.prototype.$print = print;

export {
  queries, mutations, postGraphql, query, mutate,
};
